import ResourceService from "./resource.service";

class ContractService extends ResourceService {
  static get resource() {
    return "contract";
  }
}

export default ContractService;